import React from 'react'

const Loader = () => {
  return (
    <div className="row justify-content-center">
      <div className="spinner-border" role="status" />
    </div>
  )
}

export default Loader
